import { useAtom } from 'jotai';

import { EditMyAccount, editMyAccount } from '@/store/editMyAccount';

const useEditMyAccount = () => {
  const [data, setData] = useAtom(editMyAccount);

  const updateEditMyAccount = (updates: Partial<EditMyAccount>) => {
    setData((prev) => {
      if (!prev) return updates as EditMyAccount;
      return {
        ...prev,
        ...updates,
      };
    });
  };

  const setEditMyAccount = (data: EditMyAccount) => {
    setData(data);
  };

  return {
    data,
    updateEditMyAccount,
    setEditMyAccount,
  };
};

export default useEditMyAccount;
